import { createRoutine } from 'redux-saga-routines';

const FETCH_ALL_STATES_PREFIX = 'FETCH_ALL_STATES_PREFIX';
export const fetchAllStatesAction = createRoutine(FETCH_ALL_STATES_PREFIX);
